import { buildGetMessagesKey } from "@queries/chat/useGetMessages";
import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";

type Props = {
  threadId: string | null | undefined;
};

export const useCancelLoadingMessages = (props: Props) => {
  const { threadId } = props;
  const queryClient = useQueryClient();

  useEffect(() => {
    return () => {
      if (threadId) {
        queryClient.cancelQueries({
          queryKey: buildGetMessagesKey({ threadId }),
        });
      }
    };
  }, [threadId, queryClient]);
};
